import { render, staticRenderFns } from "./ProcessesTab.vue?vue&type=template&id=523a57bd&scoped=true&"
import script from "./ProcessesTab.vue?vue&type=script&lang=js&"
export * from "./ProcessesTab.vue?vue&type=script&lang=js&"
import style0 from "./ProcessesTab.vue?vue&type=style&index=0&id=523a57bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a57bd",
  null
  
)

export default component.exports